import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const approvalFormRouter: Array<RouteRecordRaw> = [
  {
    path: '/approvalForm',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      order: 3, // 导航栏权重
      title: 'approvalFormManagement',
      icon: '#iconyijicaidan',
      roles: [
        'APPROVAL_PLAN_R', 'APPROVAL_PLAN_W', 'APPROVAL_PLAN_SR',
        'APPROVAL_HIS_R'
      ]
    },
    children: [
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "ApprovalFormPageList" */ '@/views/approval/ApprovalFormPageList.vue'),
        name: 'ApprovalFormPageList',
        meta: {
          title: 'approvalForm',
          icon: '#iconerjicaidan',
          roles: ['APPROVAL_PLAN_R', 'APPROVAL_PLAN_W', 'APPROVAL_PLAN_SR'],
          keepAlive: true
        }
      },
      {
        path: 'approvalFormDetail/:id',
        component: () => import(/* webpackChunkName: "ApprovalFormDetail" */ '@/views/approval/ApprovalFormDetail.vue'),
        name: 'approvalFormDetail',
        meta: {
          title: 'approvalFormDetail',
          hidden: true,
          noCache: true,
          roles: ['APPROVAL_PLAN_R', 'APPROVAL_PLAN_W', 'APPROVAL_PLAN_SR']
        }
      },
      {
        path: 'history',
        component: () => import(/* webpackChunkName: "ApprovalFormHistoryPageList" */ '@/views/approval/ApprovalFormHistoryPageList.vue'),
        name: 'ApprovalFormHistoryPageList',
        meta: {
          title: 'approvalFormHistory',
          icon: '#iconerjicaidan',
          roles: ['APPROVAL_HIS_R'],
          keepAlive: true
        }
      },
      {
        path: 'history/approvalFormDetail/:id',
        component: () => import(/* webpackChunkName: "ApprovalFormDetail" */ '@/views/approval/ApprovalFormHistoryDetail.vue'),
        name: 'approvalFormHistoryDetail',
        meta: {
          title: 'approvalFormHistory',
          hidden: true,
          noCache: true,
          roles: ['APPROVAL_HIS_R']
        }
      }
    ]
  }
]
export default approvalFormRouter
